import React, { useState } from 'react';
import { Box, Typography, Button, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CalloutBox = ({ contents, sx }) => {
   const [copied, setCopied] = useState(false);

   const handleCopy = () => {
      if (navigator.clipboard?.writeText) {
         navigator.clipboard.writeText(contents);
      } else {
         // navigator.clipboard only exists on secure pages (https or localhost), so fall
         // back to the older copy command, e.g. on the dev server over Tailscale.
         const textarea = document.createElement('textarea');
         textarea.value = contents;
         textarea.setAttribute('readonly', '');
         textarea.style.position = 'fixed';
         textarea.style.opacity = '0';
         document.body.appendChild(textarea);
         textarea.select();
         document.execCommand('copy');
         document.body.removeChild(textarea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
   };

   return (
      <Box
         sx={{
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '16px',
            position: 'relative',
            backgroundColor: '#f9f9f9',
            ...sx,
         }}
      >
         <Typography variant="body1">{contents}</Typography>
         <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'}>
            <Button
               onClick={handleCopy}
               variant="contained"
               color="primary"
               startIcon={<ContentCopyIcon />}
               sx={{ position: 'absolute', top: '8px', right: '8px' }}
            >
               Copy
            </Button>
         </Tooltip>
      </Box>
   );
};

export default CalloutBox;
